<div style="height: 100%;width: 100%;overflow: auto;">
    <!-- <div style="padding: 2px;">
        <form [formGroup]="createSetUpForm" (ngSubmit)="onViewClick()" style="align-items: center;">
            <div class="row" style="padding: 2px;">
                <div class="col-md-4 col-sm-6 col-6" style="padding: 0px 3px ;">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input style="cursor: pointer;" matInput [matDatepicker]="stickerView"
                                placeholder="From Date" (click)="stickerView.open()" [max]="currDate"
                                formControlName="fromDate" readonly required>
                            <mat-datepicker-toggle matSuffix [for]="stickerView"></mat-datepicker-toggle>
                            <mat-datepicker #stickerView disabled="false"></mat-datepicker>
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="col-md-4 col-sm-6 col-6 "  style="padding: 0px 3px ;">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input style="cursor: pointer;" matInput [matDatepicker]="rickerView" placeholder="To Date"
                                (click)="rickerView.open()" [min]="createSetUpForm.controls['fromDate'].value"
                                [max]="currDate" formControlName="toDate" readonly required>
                            <mat-datepicker-toggle matSuffix [for]="rickerView"></mat-datepicker-toggle>
                            <mat-datepicker #rickerView disabled="false"></mat-datepicker>
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="col-md-4 col-sm-12 col-12"  style="padding: 0px ;">
                    <button type="submit" id="btnnInsidePage">
                        VIEW<mat-icon class="icon-style">search</mat-icon>
                    </button>
                </div>
            </div>
        </form>
    </div>

    <div id="table_shipping_report">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8"
            style="width: max-content !important; min-width: 100%;">
            <caption></caption>

            <ng-container matColumnDef="date">
                <th scope="col" mat-header-cell *matHeaderCellDef> Date </th>
                <td mat-cell *matCellDef="let element" id="text_align">{{element.onDate}}</td>
                <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"></td>
            </ng-container>

            <ng-container matColumnDef="shippingNo">
                <th scope="col" mat-header-cell *matHeaderCellDef> Shipping No </th>
                <td mat-cell *matCellDef="let element" id="text_align">{{element.shippingNo}}</td>
                <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"></td>
            </ng-container>

            <ng-container matColumnDef="tripNo">
                <th scope="col" mat-header-cell *matHeaderCellDef> Trip No. </th>
                <td mat-cell *matCellDef="let element" id="number_align">{{element.tripNo}}</td>
                <td mat-footer-cell *matFooterCellDef id="number_align" style="color: white; border: none;">
                    {{sumQty}}</td>
            </ng-container>

            <ng-container matColumnDef="amount">
                <th scope="col" mat-header-cell *matHeaderCellDef> Amount </th>
                <td mat-cell *matCellDef="let element" id="number_align">{{element.amount | number : '1.2-2'}}</td>
                <td mat-footer-cell *matFooterCellDef id="number_align" style="color: white; border: none;">
                    {{sumAmount | number : '1.2-2'}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true;"></tr>
        </table>
    </div> -->

    <div style="display: flex;">
        <div type="button" style="margin-left: 2px;" (click)="divClick('Daily',toDate,toDate)" id="daily"
            class="btn btn-secondary btn-sm">Daily</div>
        <div type="button" style="margin-left: 2px;" (click)="divClick('Weekly',firstDayOfWeek,toDate)" id="weekly"
            class="btn btn-secondary btn-sm">Weekly</div>
        <div type="button" style="margin-left: 2px;" (click)="divClick('Monthly',fromDate,toDate)" id="monthly"
            class="btn btn-secondary btn-sm">Monthly</div>
    </div>

    <div style="padding-top: 3px;">
        <mat-card class="contain_card">
            <mat-form-field class="selectOption">
                <mat-select placeholder="Date Range" (selectionChange)="onFilterSelect($event.value)"
                    [(value)]="selectedValue">
                    <mat-option *ngFor="let type of filterData " [value]="type ">
                        {{type}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-card>
    </div>

    <div style="max-width: 100%; padding: 0px 10px;">
        <p style="margin-top: 10px;padding-left: 2px;"><b id="performanceHead">Today's performance</b></p>

        <div *ngIf="filteredData.length > 0; else noDataTemplate">
            <div *ngFor="let item of filteredData; let i = index" class="main-data-row"
                [ngStyle]="{'background-color': item.showDetails ? '#d3d3d3' : (i % 2 === 0 ? '#f0f0f0' : '#fff')}">
                <div class="data-row" [ngClass]="{'white-background': i % 2 === 0, 'gray-background': i % 2 !== 0}">
                    <div class="data-cell">
                        {{ item.onDate }}<br>
                        <p>Date</p>
                    </div>

                    <div class="data-cell">
                        {{ item.shippingNo }}<br>
                        <p>Shipping No</p>
                    </div>

                    <div class="data-cell">
                        {{ item.tripNo }}<br>
                        <p>Trip No.</p>
                    </div>

                    <div class="data-cell">
                        {{ item.amount | number : '1.2-2' }}<br>
                        <p>Amount</p>
                    </div>
                </div>

                <div *ngIf="!item.showDetails" class="details-opem-icon"
                    (click)="toggleDetails(item.onDate, item.shippingNo, item.tripNo)">
                    <mat-icon style="color: green;">keyboard_arrow_down</mat-icon>
                </div>

                <div *ngIf="item.showDetails" class="details-opem-icon"
                    (click)="toggleDetails(item.onDate, item.shippingNo, item.tripNo)">
                    <mat-icon>keyboard_arrow_up</mat-icon>
                </div>

                <div class="details" [ngClass]="{'open': item.showDetails}">
                    <p style="margin-bottom: 0rem !important; font-size: 15px;">Additional Details:</p>

                    <div style="height: 92%;padding: 1%;overflow: auto;">
                        <div *ngFor="let data of item.shippingFareShippingWise"
                            style="padding: 2px; background-color: #e8e8e8;">
                            <span class="holding_span_sr">
                                <p class="holding_pg_left_sr">Date</p>
                                <p class="holding_pg_right_sr">: {{data.onDate}} </p>
                            </span>

                            <span class="holding_span_sr">
                                <p class="holding_pg_left_sr">Shipping No</p>
                                <p class="holding_pg_right_sr">: {{data.usedForRefNo}} </p>
                            </span>

                            <span class="holding_span_sr" *ngIf="data.transactionName">
                                <p class="holding_pg_left_sr">Against</p>
                                <p class="holding_pg_right_sr">: {{data.transactionName}} </p>
                            </span>

                            <span class="holding_span_sr">
                                <p class="holding_pg_left_sr">Pick Up Location</p>
                                <p class="holding_pg_right_sr">: {{data.pickupLocation}} </p>
                            </span>

                            <span class="holding_span_sr">
                                <p class="holding_pg_left_sr">Start Location</p>
                                <p class="holding_pg_right_sr">: {{data.fromLocationName}} </p>
                            </span>

                            <span class="holding_span_sr">
                                <p class="holding_pg_left_sr">Destination Location</p>
                                <p class="holding_pg_right_sr">: {{data.toLocationName}} </p>
                            </span>

                            <div class="parent_div_shipping_report">
                                <div class="col-md-12 col-sm-12 col-12 cart_div_shipping_report">
                                    <table class="mat-elevation-z8">
                                        <tr>
                                            <th></th>
                                            <th>Suggested</th>
                                            <th>Actual</th>
                                        </tr>
                                        <tr style="background-color: #c5c5c5;">
                                            <td>Distance</td>
                                            <td>{{data.distance | number : '1.2-2'}} km</td>
                                            <td>{{data.servicemanDistanceCovered | number : '1.2-2'}} km</td>
                                        </tr>
                                        <tr style="background-color: #c5c5c5;">
                                            <td>Duration</td>
                                            <td>{{data.duration | number : '1.2-2'}} min</td>
                                            <td>{{data.servicemanTrafficDuration | number : '1.2-2'}} min</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>

                            <span class="holding_span_sr">
                                <p class="holding_pg_left_sr">Weather Condition</p>
                                <p class="holding_pg_right_sr">: {{data.weatherCondition}} </p>
                            </span>

                            <span class="holding_span_sr">
                                <p class="holding_pg_left_sr">Traffic Condition</p>
                                <p class="holding_pg_right_sr">: {{data.trafficCondition}} </p>
                            </span>

                            <span class="holding_span_sr">
                                <p class="holding_pg_left_sr">Min. Pay/Delivery</p>
                                <p class="holding_pg_right_sr">: &#8377;{{data.fixedPayPerKm | number : '1.2-2'}} </p>
                            </span>

                            <span class="holding_span_sr">
                                <p class="holding_pg_left_sr">Variable Pay</p>
                                <p class="holding_pg_right_sr">: &#8377;{{data.variablePay | number : '1.2-2'}} </p>
                            </span>

                            <span class="holding_span_sr">
                                <p class="holding_pg_left_sr">Surge Pay(Weather)</p>
                                <p class="holding_pg_right_sr">: &#8377;{{data.weatherPay | number : '1.2-2'}} </p>
                            </span>

                            <span class="holding_span_sr">
                                <p class="holding_pg_left_sr">Surge Pay(Traffic)</p>
                                <p class="holding_pg_right_sr">: &#8377;{{data.trafficPay | number : '1.2-2'}} </p>
                            </span>

                            <span class="holding_span_sr">
                                <p class="holding_pg_left_sr">Surge Pay({{data.surgeName}})</p>
                                <p class="holding_pg_right_sr">: &#8377;{{data.surgePay | number : '1.2-2'}} </p>
                            </span>

                            <span class="holding_span_sr"  [ngClass]="{'disputed': data.disputeCurrentStatus}">
                                <p class="holding_pg_left_sr" style="font-weight: bold;">Net Amount</p>
                                <p class="holding_pg_right_sr" style="font-weight: bold;">: &#8377;{{data.netAmount |
                                    number
                                    : '1.2-2'}}
                                </p>
                            </span>

                            <span *ngIf="data.disputeCurrentStatus" class="holding_span_sr">
                                <p class="holding_pg_left_sr" style="font-weight: bold;">Final Amount</p>
                                <p class="holding_pg_right_sr" style="font-weight: bold;">: &#8377;{{data.finalAmount |
                                    number
                                    : '1.2-2'}}
                                </p>
                            </span>

                            <div style="margin-top: 3%;">
                                <button *ngIf="!data.disputeCurrentStatus" type="button"
                                    id="shipping_btn_shipping_report"
                                    (click)="onSaveRaiseDisputeClick(data.shippingFareShippingWise)">
                                    Raise Dispute
                                </button>
                                <button *ngIf="data.disputeCurrentStatus" type="button"
                                    id="shipping_btn_shipping_report">
                                    {{data.disputeCurrentStatus}}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>


        <ng-template #noDataTemplate>
            <div style="text-align: center; padding: 10px;">
                <img src="./assets/images/result-wrong-icon (1).svg" alt="" style=" height: 100px;">
                <p style="color: #cdcccc !important;">Nothing to show here</p>
            </div>
        </ng-template>

    </div>

    <div
        style="display: flex; padding-left: 2px; font-size: medium; padding-top: 8px; padding-bottom: 8px; margin: 10px 8px; border-radius: 5px; border: 1px solid #cdcccc;">
        <div style="width: 70%;">
            <b id="totEarning"> Total Earnings for today</b>
        </div>
        <div style="text-align: center;width: 30%;">
            <b>{{sumAmount}}</b>
        </div>

    </div>

    <div
        style="display: flex; padding-left: 2px; font-size: medium; padding-top: 8px; padding-bottom: 8px; margin: 10px 8px; border-radius: 5px; border: 1px solid #cdcccc;">
        <div style="width: 70%;">
            <b id="totTrip"> Total Trips for today</b>
        </div>
        <div style="text-align: center;width: 30%;">
            <b>{{calculateTrip.length}}</b>
        </div>

    </div>
</div>